import { arkEncryptionService } from './EncryptionService';

export class HttpApiClient {
	static async get(url: string, headers: Record<string, string> = {}, options: RequestInit = {}) {
		return fetch(url, {
			...options,
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				...headers,
			},
		});
	}

	static async post(
		url: string,
		headers: Record<string, string>,
		body: any,
		isArkApi: boolean = true,
		options: RequestInit = {},
	) {
		if (isArkApi) {
			body = JSON.stringify(arkEncryptionService.buildSecurePayload(body));
		} else {
			body = JSON.stringify(body !== undefined ? body : {});
		}
		return fetch(url, {
			...options,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...headers,
			},
			body: body,
		});
	}

	static async put(
		url: string,
		headers: Record<string, string>,
		body: any,
		isArkApi: boolean = true,
		options: RequestInit = {},
	) {
		if (isArkApi) {
			body = JSON.stringify(arkEncryptionService.buildSecurePayload(body));
		} else {
			body = JSON.stringify(body !== undefined ? body : {});
		}
		return fetch(url, {
			...options,
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				...headers,
			},
			body: body,
		});
	}

	static async delete(
		url: string,
		headers: Record<string, string>,
		body: any,
		isArkApi: boolean = true,
		options: RequestInit = {},
	) {
		if (isArkApi) {
			body = JSON.stringify(arkEncryptionService.buildSecurePayload(body));
		} else {
			body = JSON.stringify(body !== undefined ? body : {});
		}
		return fetch(url, {
			...options,
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				...headers,
			},
			body: body,
		});
	}
}
